<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: 'Encuesta',
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <div v-for="item in form.items" :key="item.id" class="mt-3">
                <AppWell>
                    <AppCard>
                        <div class="p-2">
                            <div class="font-semibold">
                                {{ $t('messages.sociogram_relationship_explanation_for_students', { max: item.max }) }}
                            </div>
                            <div>
                                {{ item.title }}
                            </div>
                            <div class="md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-6">
                                <label v-for="student in students" :key="student.id">
                                    <input
                                        type="checkbox"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                        :name="`item_${item.id}`"
                                        :value="student.id"
                                        :disabled="
                                            item.user_ids.length >= item.max && !item.user_ids.includes(student.id)
                                        "
                                        v-model="item.user_ids"
                                    />
                                    <BadgePill :color="item.user_ids.includes(student.id) ? 'indigo' : 'gray'">
                                        {{ student.full_name }}
                                    </BadgePill>
                                </label>
                            </div>
                        </div>
                    </AppCard>
                </AppWell>
            </div>
            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import BadgePill from '@/components/BadgePill.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        BadgePill,
        AppCard,
        AppWell,
        PanelPage,
    },
    layout: Layout,
    name: 'Create',
    props: ['students', 'items', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                items: this.items,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
